export const ROUTES = {
  HOME: '/',
  PRODUCT: `/angebote/:id`,
  ANGEBOTE: `/angebote`,
  CONTACT: '/contact-us',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  FAQ: '/faq',
  SEARCH: '/search',
  PRODUCTS: '/angebote',
  CATEGORY: '/kategorien',
  BRAND: '/marken',
  getCategoryPath: (slug?: string) => slug ? `/kategorien/${slug}` : '/kategorien',
  getBrandPath: (slug?: string) => slug ? `/marken/${slug}` : '/marken',
};